import { z } from 'zod'

export const LoginFormSchema = z.object({
    username: z.string().min(1).max(255),
    password: z.string().min(1).max(255),
    code: z.string().max(6).min(6).optional(),
})

export type LoginFormType = z.infer<typeof LoginFormSchema>
